import { combineReducers } from "@reduxjs/toolkit";

import commonReducer from "./slice";
import authReducer from "../modules/auth/stores/slice";
import zoneReducer from "../modules/zone/stores/slice";
import locationReducer from "../modules/location/stores/slice";
import subZoneReducer from "../modules/subZone/stores/slice";

const appReducer = combineReducers({
  common: commonReducer,
  auth: authReducer,
  zone: zoneReducer,
  location: locationReducer,
  subZone: subZoneReducer,
});

// Logout resets the ENTIRE store to initial state (passing undefined runs
// every slice's default), so no user data lingers for the next session.
const rootReducer = (state, action) => {
  if (action.type === "auth/doLogout") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
